import React from 'react';

import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';

import Button from 'components/Button';
import Trash from 'components/SvgComponents/icons/Trash';
import useAuthSession from 'hooks/useAuthSession';
import globalMessages from 'translations/messages/global-messages';

import DialogDeleteAccount from './DialogDeleteAccount';

const styles = () => ({
  button: {
    whiteSpace: 'nowrap',
  },
});

function DeleteAccount({ userEmail, intl, openModal, setOpenModal, classes, onDeleteAccount }) {
  const { logout } = useAuthSession();

  const toggleModal = () => {
    setOpenModal(!openModal);
  };

  const handleDeleteAccount = () => {
    const deleteAccountSuccessCallback = async () => {
      await logout();
    };

    // call to delete account service
    onDeleteAccount({ deleteAccountSuccessCallback });
    toggleModal();
  };

  return (
    <div>
      <Button
        variant="danger"
        className={classes.button}
        onClick={() => toggleModal()}
        aria-label={intl.formatMessage(globalMessages.account_settings_delete_account_button)}
        startIcon={<Trash color="inherit" />}
      >
        {intl.formatMessage(globalMessages.account_settings_delete_account_button)}
      </Button>
      {openModal && (
        <DialogDeleteAccount
          onCloseDialog={toggleModal}
          onSubmitDialog={handleDeleteAccount}
          userEmail={userEmail}
        />
      )}
    </div>
  );
}

DeleteAccount.propTypes = {
  userEmail: PropTypes.string,
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  openModal: PropTypes.bool,
  setOpenModal: PropTypes.func,
  onDeleteAccount: PropTypes.func,
};

export default compose(
  injectIntl,
  withStyles(styles),
)(DeleteAccount);
